export default {
	refGridLayout: null,
	widgetItems: [],
	widgetMaster: [],
	widgetSideBar: false,
	dynamicComp: {}, //{name: {component, widgetKey , ...}}
	displayCoachMarkFlag: true
};
